import m from "../../../../geodata/es2015/region/usa/alHigh";
window.am4geodata_region_usa_alHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/alHigh.js
// module id = null
// module chunks = 